import { commonEnums } from '@codametrix/ui-common';
import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import './styles/index.scss';
const { CaseArtifactTypes } = commonEnums;

const externalSource: Set<string> = new Set(
  [
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CODED,
    CaseArtifactTypes.CLAIM
  ].map(code => code.toLowerCase())
);

const displayNoEvidenceAvailable = (
  artifact: CMxArtifacts.EnhancedCaseArtifacts
) => {
  let text = '';

  if (artifact.meta?.imported === true) {
    text = 'This code was billed on a different case';
  } else {
    text = externalSource.has(artifact.type.toLowerCase())
      ? `This code originated in your health system.`
      : `There is no displayable evidence at this time.`;
  }

  return (
    <ul className="case-evidence-list">
      <li>
        <span className="qa-empty-message">{text}</span>
      </li>
    </ul>
  );
};

const buildClickHandler = (
  onSelection: CMxCommonApp.OnFeatureSelection,
  evidence: CMxAPI.UnionEvidence[]
) => {
  return (ev: React.MouseEvent<HTMLUListElement>) => {
    ev.preventDefault();
    const target =
      (ev.target as HTMLSpanElement) || document.createElement('span');

    const valuable = target.classList.contains('field-value');
    const linkable = target.closest('.case-evidence-item.case-evidence-linked');
    if (!valuable || !linkable) return;

    const item = target.attributes.getNamedItem('data-index');
    if (!item) return;

    const currentIndex = parseInt(item.value);
    const feature = evidence[currentIndex];

    const display = !linkable.classList.contains('case-evidence-active');

    onSelection({
      evidence: feature,
      display
    } as CMxArtifacts.FeatureSelection);
  };
};

export { externalSource, displayNoEvidenceAvailable, buildClickHandler };
